import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  FetchRecordingCourse,
  FetchRecordingCourseFrontend,
  FetchRecordingCourseFrontendDetail,
  FetchRecordingCourseDetail,
  fetchOrderRecordingCourse,
  fetchOrderRecordingCourseDetail,
} from "../api/RecordingCourseApi";

export const FetchRecordingCourseAsync = createAsyncThunk(
  "recording_course/backend",
  async ({ path }, { rejectWithValue }) => {
    try {
      const response = await FetchRecordingCourse(path);
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const FetchRecordingCourseFrontendAsync = createAsyncThunk(
  "recording_course/frontend",
  async ({ path }, { rejectWithValue }) => {
    try {
      const response = await FetchRecordingCourseFrontend(path);
      console.log(response, "<<<response thunk");
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const FetchRecordingCourseFrontendDetailAsync = createAsyncThunk(
  "recording_course/frontend/details",
  async ({ path, id, userID }, { rejectWithValue }) => {
    try {
      const response = await FetchRecordingCourseFrontendDetail(
        path,
        id,
        userID
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const FetchRecordingCourseDetailAsync = createAsyncThunk(
  "recording_course/details",
  async ({ path, id }, { rejectWithValue }) => {
    try {
      const response = await FetchRecordingCourseDetail(path, id);
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const fetchOrderRecordingCourseAsync = createAsyncThunk(
  "recordingCourse/fetchOrderRecordingCourse",
  async (path) => {
    const response = await fetchOrderRecordingCourse(path);
    return response.data.data;
  }
);

export const fetchOrderRecordingCourseDetailAsync = createAsyncThunk(
  "recordingCourse/fetchOrderRecordingCourseDetail",
  async (routeData) => {
    const { path, id } = routeData;

    const response = await fetchOrderRecordingCourseDetail(path, id);
    return response.data;
  }
);
